<template>
  <v-app>
  <div>
      <div v-if="nodetype == 'usecase'">      
        <Page_Usecase :node="node" ></Page_Usecase>
      </div>
      <div v-if="nodetype == 'field'">
        <Page_Testfield :node="node" ></Page_Testfield>
      </div>
      <div v-if="nodetype == 'device'">
        <Page_Device :node="node" ></Page_Device>
      </div>      
  </div>
  <Footer></Footer>
  </v-app>
</template> 

<script>

import Page_Testfield from './content/Page_Testfield';
import Page_Usecase from './content/Page_Usecase';
import Page_Device from './content/Page_Device';
import Footer from './elements/Footer';

export default {
  name: 'ContentFront',

  components: {
    Page_Testfield,
    Page_Usecase,
    Page_Device,
    Footer
  },
  data() {
      return {
        nodetype: this.$route.params.nodetype ? this.$route.params.nodetype : 'field',
        node: {},
        usecases: null,
        testfields: null,
        nodeid: this.$route.params.nodeid ? this.calcURL(this.$route.params.nodeid) : this.$route.params.url
      }
  },
  props: {
    query: {      
    }
  },
  methods: {

      calcURL (nodeid) {        
        // console.log(nodeid);
        return nodeid ? nodeid : null;
      },

      getNode() {
          let self = this;
          this.axios.get( this.$config.host+"/" + this.nodetype + "/" + this.nodeid ).then(function (response) {
            self.node = response.data;
            if(response.data != null) {
              self.$store.commit('setNode', response.data);
            }
          });
      },

  },
  mounted() {
      this.getNode();
  },
  computed: {    

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>
